<template>
  <div>
    <v-container v-if="access.read" fluid class="mx-12 my-6">
      <div class="card-label d-flex flex-row mb-4">
        <v-icon>mdi-image-broken</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Complaints</p>
      </div>
      <v-row class="mb-6">
        <v-col class="py-0" cols="12" sm="8" md="8">
          <v-text-field
            v-model="searchString"
            solo
            flat
            append-icon="mdi-magnify"
            label="Search Complaint"
            hide-details
            @click:append="searchAction"
            @keydown.enter="searchAction"
          >
          </v-text-field>
        </v-col>
        <v-col class="py-0" cols="12" sm="4" md="4">
          <v-select
            v-model="filterStatus"
            solo
            flat
            hide-details
            label="Show Items"
            :items="filterItems"
            @change="searchAction"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-card v-show="!loading" elevation="0" class="card-container px-8 py-4">
        <v-data-table
          :search="searchString"
          :headers="headers"
          :items="complaints"
          :options.sync="options"
          :server-items-length="total"
          item-key="refNo"
          class="elevation-0"
          :loading="loading"
          loading-text="Loading... Please wait"
          no-data-text="All Complaints from tenants will appear here."
          multi-sort
          dense
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr class="tr-head" @click="openDetails(item)">
              <td>
                <p class="caption">{{ item.refNo }}</p>
              </td>
              <td class="text-overflow">
                <span class="caption">{{ item.requester }}</span>
              </td>
              <td>
                <p class="caption">{{ item.complaintTitle }}</p>
              </td>
              <td>
                <p class="caption">{{ item.dateCreated }}</p>
              </td>
              <td>
                <p v-if="item.status == 'pending'" class="caption red--text">
                  {{ showStatusText(item.status) }}
                </p>
                <p
                  v-if="item.status == 'in_progress'"
                  class="caption blue--text"
                >
                  {{ showStatusText(item.status) }}
                </p>
                <p
                  v-if="item.status == 'resolved'"
                  class="caption green--text text--darken-1"
                >
                  {{ showStatusText(item.status) }}
                </p>
                <p v-if="item.status == 'rejected'" class="caption grey--text">
                  {{ showStatusText(item.status) }}
                </p>
              </td>
              <td>
                <v-tooltip bottom dark>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      x-small
                      icon
                      v-on="on"
                      @click.stop="openDetails(item)"
                    >
                      <v-icon small>mdi-update</v-icon>
                    </v-btn>
                  </template>
                  <span style="color: white">Update</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-skeleton-loader
        v-show="loading"
        ref="skeleton"
        type="table"
        loading
        class="mx-auto"
      ></v-skeleton-loader>
    </v-container>
    <ComplaintDetails ref="complaintDetails"></ComplaintDetails>
  </div>
</template>

<script>
import ComplaintDetails from '../components/complaint/ComplaintDetails.vue'

export default {
  components: {
    ComplaintDetails
  },
  data() {
    return {
      searchString: '',
      loading: true,
      limit: 0,
      total: 0,
      options: {},
      resolveDialog: false,
      filterStatus: 'all',
      filterItems: [
        { text: 'Show: All', value: 'all' },
        { text: 'Show: Pending', value: 'pending' },
        { text: 'Show: In Progress', value: 'in_progress' },
        { text: 'Show: Rejected', value: 'rejected' },
        { text: 'Show: Resolved', value: 'resolved' }
      ],
      statuses: [
        { value: 'pending', text: 'Pending' },
        { value: 'in_progress', text: 'In Progress' },
        { value: 'resolved', text: 'Resolved' },
        { value: 'rejected', text: 'Rejected' }
      ]
    }
  },
  computed: {
    complaints() {
      return this.$store.getters['complaints/getComplaints']
    },
    headers() {
      return this.$store.getters['complaints/getHeaders']
    },
    access() {
      return this.$root.$roleAccess('complaints').access
    }
  },
  watch: {
    options: {
      handler() {
        this.refresh()
      }
    }
  },
  mounted() {},
  methods: {
    searchAction() {
      this.loading = true
      this.$store
        .dispatch('complaints/fetchComplaintsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.filterStatus
        })
        .then((data) => {
          this.loading = false
          this.limit = data.limit
          this.total = data.count
        })
    },
    openDetails(item) {
      this.$refs.complaintDetails.open(item, this.refresh)
    },
    refresh() {
      this.loading = true
      this.$store
        .dispatch('complaints/fetchComplaintsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.filterStatus
        })
        .then((data) => {
          this.loading = false
          this.limit = data.limit
          this.total = data.count
        })
    },
    showStatusText(status) {
      return this.statuses.find((s) => s.value == status).text
    }
  }
}
</script>

<style scoped>
.card-container {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
p {
  margin-bottom: 0;
}
.text-overflow {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
